<template>
    <div class="core_waybills">
        <table class="ui compact celled selectable table">
            <thead class="center aligned">
                <tr class="center aligned">
                    <th v-if="show_update_button">
                        <!-- 快速更新 -->
                        {{ $t('ui.toolbox.core_waybills.quick_update') }}
                    </th>

                    <th v-for="column in columns">{{ column.human_name }}</th>
                    <th>
                        <div class="ui basic icon button" @click="show_filter = !show_filter">
                            <i class="angle double up icon" v-if="show_filter"></i>
                            <i class="angle double down icon" v-else></i>
                        </div>
                    </th>
                </tr>
                <tr class="center aligned" v-show="show_filter">
                    <th v-if="show_update_button">
                        <button class="ui basic positive icon button" @click="add_all_to_quick_update">
                            <i class="plus icon"></i>
                        </button>
                    </th>
                    <th v-for="column in columns" style="overflow: visible;">
                        <div class="ui mini input" v-if="column.input_type">
                            <input type="text" v-model="search_params[column.name]" @keyup.enter="fetch_core_waybills" v-if="column.input_type == 'text'">
                            <input type="number" v-model="search_params[column.name]" @keyup.enter="fetch_core_waybills" v-if="column.input_type == 'number'">
                            <select v-dropdown v-model="search_params.material.class_names" v-if="column.input_type == 'materials'">
                                <option value>{{ $t('ui.general.please_select') }}</option>
                                <option v-for="material in materials" :value="material.class_name">{{ material.name }}</option>
                            </select>
                            <div class="ui checkbox" v-if="column.input_type == 'checkbox'">
                                <input type="checkbox" v-model="search_params[column.name]">
                                <label></label>
                            </div>
                        </div>
                    </th>
                    <th>
                        <div class="ui icon mini buttons">
                            <div class="ui black basic button" @click.prevent="fetch_core_waybills" title="搜尋">
                                <i class="search icon"></i>
                            </div>
                            <div class="ui black basic button" @click.prevent="init_search_params" title="清除搜尋條件">
                                <i class="refresh icon"></i>
                            </div>
                            <div class="ui black basic button" @click.prevent="fetch_core_waybills('csv')" title="匯出csv" v-if="show_export_csv_button">
                                <i class="file alternate icon"></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="show_core_waybills">
                <CoreWaybill
                    v-for="core_waybill in core_waybills"
                    :core_waybill="core_waybill"
                    :columns="columns"
                    :key="core_waybill.identity"
                    :scope="scope"
                    :show_delete_button="show_delete_button"
                    :show_update_button="show_update_button"
                    >
                </CoreWaybill>
                <tr v-if="core_waybills.length <= 0" class="center aligned">
                    <td colspan="8" >
                        <h5>{{ $t('ui.general.no_data') }}</h5>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="loading">
                    <td colspan="8">
                        <div class="ui active centered inline loader"></div>
                    </td>
                </tr>
            </tbody>
        </table>


        <Paginator
            v-if="core_waybills.length > 0"
            :total_pages="pagination.total_pages"
            :current_page="pagination.current_page"
            change_page_channel="core_waybills_pagination"
        />

        <Updater :core_waybills="quick_update_core_waybills" :updater_columns="updater_columns"></Updater>
    </div>
</template>

<script>
import CoreWaybill from './.components/core_waybill.vue'
import Paginator from '@toolbox/pagination/paginator.vue'
import Updater from './.components/updater.vue'
export default {
    name: "ToolCoreWaybillsMain",
    props: {
        columns: {
            type: Array,
            default() {
                return [
                    {
                        input_type: "materials",
                        display_type: "material",
                        name: "materials",
                        human_name: "類型",
                    },
                    {
                        input_type: "text",
                        display_type: "text",
                        name: "number",
                        human_name: "單號",
                    },
                    {
                        input_type: "text",
                        display_type: "text",
                        name: "consignee_phone",
                        human_name: "收件人電話",
                    },
                    {
                        input_type: "number",
                        display_type: "text",
                        name: "weight_in_kilo",
                        human_name: "重量",
                    },
                    {
                        input_type: "number",
                        display_type: "text",
                        name: "collection",
                        human_name: "代收貨款",
                    },
                    {
                        input_type: null,
                        display_type: "status",
                        name: "latest_status",
                        human_name: "貨況",
                    },
                    {
                        input_type: "checkbox",
                        display_type: "boolean",
                        name: "is_done",
                        human_name: "完成",
                        default_value: false,
                    },
                ]
            },
        },
        updater_columns: {
            type: Array,
            default() {
                return [
                    {
                        toggle: false,
                        header_text: "原單號",
                        attribute_name: "original_number",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "追蹤號碼(聯運單號)",
                        attribute_name: "tracking_number",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "寄件人姓名",
                        attribute_name: "sender_name",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "寄件人地址",
                        attribute_name: "sender_address",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "寄件人電話",
                        attribute_name: "sender_phone",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "收件人姓名",
                        attribute_name: "consignee_name",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "收件人地址",
                        attribute_name: "consignee_address",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "收件人電話",
                        attribute_name: "consignee_phone",
                        type: "text",
                    },
                    {
                        toggle: false,
                        header_text: "重量",
                        attribute_name: "weight_in_kilo",
                        type: "number",
                    },
                    {
                        toggle: false,
                        header_text: "代收貨款",
                        attribute_name: "collection",
                        type: "number",
                    },
                ]
            }
        },
        theme: {
            type: String,
            default: "default",
        },
        default_search_params: {
            type: Object,
            default() {
                return {}
            },
        },
        scope: String,
        show_delete_button: {
            type: Boolean,
            default: false,
        },
        show_update_button: {
            type: Boolean,
            default: false,
        },
        show_export_csv_button: {
            type: Boolean,
            default: false,
        },
        csv_file_name: {
            type: String,
            default: "data",
        },
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            show_filter: true,
            show_core_waybills: false,
            core_waybills: [],
            materials: [],
            search_params: {
                number: null,
                material: {
                    class_names: null,
                }
            },
            pagination: {
                total_pages: null,
                current_page: null,
            },
            quick_update_core_waybills: [],
        }
    },
    computed: {
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.init_search_params()
            await this.fetch_materials()
            await this.fetch_core_waybills()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })

            // pagination channel
            this.$bus.$off('core_waybills_pagination')
            this.$bus.$on('core_waybills_pagination', (page) => {
                this.pagination.current_page = page
                this.fetch_core_waybills()
            })
        },
        fetch_core_waybills(mime="json") {
            var filter = _.cloneDeep(this.search_params)
            // where_like add %% staring
            _.forEach([
                "number","flight_number","original_number","tracking_number","sender_name","consignee_name","consignee_address","consignee_phone","note"
            ], name => {
                if (filter[name]) {
                    filter[name] = "%"+filter[name]+"%"
                }
            })

            this.show_core_waybills = false
            switch (this.scope) {
                case "provider":
                    if (mime == "csv") {
                        var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills + "." + mime).parse(
                            {},
                            "?" + object_to_query(this.default_search_params)
                        )
                    } else {
                        var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                            {},
                            "?" + object_to_query(this.default_search_params) + "&" + object_to_query(filter) + "&" + object_to_query({page: this.pagination.current_page})
                        )
                    }
                    var token = localStorage.getItem("authentication_token")
                    break
                case "customer":
                    var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_core_waybills_filter).parse(
                        {},
                        "?" + object_to_query(this.default_search_params) + "&" + object_to_query(filter) + "&" + object_to_query({page: this.pagination.current_page})
                    )
                    var token = localStorage.getItem("customer_authentication_token")
                    break
            }

            return axios.get(url, {headers: { Authorization: token }})
                .then(response => {
                    if (response.data.status == "success") {
                        if (mime == "csv") {
                            var downloadLink = document.createElement("a")
                            var blob = new Blob(["\ufeff", response.data.csv])
                            var url = URL.createObjectURL(blob)
                            downloadLink.href = url
                            downloadLink.download = this.csv_file_name + ".csv"
                            document.body.appendChild(downloadLink)
                            downloadLink.click()
                            document.body.removeChild(downloadLink)
                        } else {
                            this.core_waybills = response.data.core_waybills
                            this.pagination = response.data.pagination
                        }
                    } else if (response.data.status == "failure") {
                        // this.$noty.error("抓取運單失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.core_waybills'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取運單失敗" + this.$t('ui.general.network_abnormality')+": "+ )
                    this.errors.push(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + this.$t('ui.general.network_abnormality') + ',' + error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
                .then(() => {
                    this.show_core_waybills = true
                })
        },
        init_search_params() {
            $(".core_waybills .ui.dropdown").dropdown('clear')
            this.search_params = {
                number: null,
                material: {
                    class_names: null,
                }
            }
            for (let column of this.columns) {
                if (column.default_value != null) {
                    this.search_params[column.name] = column.default_value
                }
            }
        },
        fetch_materials() {
            switch (this.scope) {
                case "provider":
                    var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_materials).parse(
                        {},
                        ""
                    )
                    var token = localStorage.getItem("authentication_token")
                    return axios.get(url, { headers: { Authorization: token }})
                        .then(response => {
                            this.materials = response.data.materials
                        })
                        .catch(error => {
                            // this.errors.push("抓取物料失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                            this.$noty.error(
                                this.$t('ui.notifications.error.fetch__name', {
                                    name: this.$t('models.materials'),
                                    reason: ': ' + error.response.status
                                })
                            )
                            return Promise.reject(error)
                        })
                    break
                case "customer":
                    var token = localStorage.getItem("customer_authentication_token")
                    return Promise.resolve()
                    break
            }
        },
        add_all_to_quick_update() {
            for (let core_waybill_component of _.filter(this.$children, (o) => {return o.$options._componentTag == "CoreWaybill"})) {
                core_waybill_component.add_to_quick_update()
            }
        },
        remove_all_core_waybills() {
            for (let cw of this.core_waybills) {
                this.$parent.remove_core_waybill(cw.identity)
            }
        },
    },
    components: {
        CoreWaybill,
        Paginator,
        Updater,
    }
}
</script>

<style scoped>
</style>
